import * as React from 'react';

import { HeaderContainer } from './header';
import { WidgetMenuContainer } from './widgetMenu';
import { WidgetCanvasContainer } from './widgetCanvas';
import { WidgetEditorContainer } from './widgetEditor';
import { ModalContainer } from './modal';

export default class EditorApp extends React.Component<any, void> {
    render() {
        return (
            <div>
                <HeaderContainer />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-3 col-md-2 sidebar">
                            <WidgetMenuContainer />
                        </div>
                        <div className="col-sm-6 col-sm-offset-3 col-md-8 col-md-offset-2 main">
                            <div className="row">
                                <div className="col-xs-12">
                                    <WidgetCanvasContainer />
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-3 col-md-2 editorbar">
                            <WidgetEditorContainer />
                        </div>
                    </div>
                </div>

                <ModalContainer />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EditorApp.tsx